import { render, staticRenderFns } from "./selectUserTableDialog.vue?vue&type=template&id=706bfb98&scoped=true"
import script from "./selectUserTableDialog.vue?vue&type=script&lang=js"
export * from "./selectUserTableDialog.vue?vue&type=script&lang=js"
import style0 from "./selectUserTableDialog.vue?vue&type=style&index=0&id=706bfb98&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706bfb98",
  null
  
)

export default component.exports